<template>
  <v-sheet>
    <div>
      <h1 class="text-center">{{ value.title }}</h1>
      <div class="font-italic font-weight-light text-center w-100">
        {{ value.shortDescription }}
      </div>
    </div>

    <hr/>
    <v-row no-gutters class="ml-4 my-2">
      <div class="mx-auto d-flex flex-wrap">
        <div class="font-weight-light subtitle-1 font-weight-bold mr-2 text-center">
          Are you going?
        </div>

        <div class="d-flex">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                small
                :loading="loading"
                :outlined="!buttonSelected('yes')"
                :tile="buttonSelected('yes')"
                class="mr-2"
                color="primary"
                v-on="on"
              >
                I'm Going
              </v-btn>
            </template>
            <v-list :key="selectedRSVP">
              <v-list-item
                @click="rsvpClick({eventId: value.id, going: 'yes', extra: 0})"
              >
                <v-list-item-title
                  :class="selectedRSVP === 'yes0' ? 'selected-item' : ''"
                >
                  Just me
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="rsvpClick({eventId: value.id, going: 'yes', extra: 1})"
              >
                <v-list-item-title
                  :class="selectedRSVP === 'yes1' ? 'selected-item' : ''"
                >Me and a friend!
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="rsvpClick({eventId: value.id, going: 'yes', extra: 2})"
              >
                <v-list-item-title
                  :class="selectedRSVP === 'yes2' ? 'selected-item' : ''"
                >Me and 2 friends!!
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            small
            :loading="loading"
            :outlined="!buttonSelected('maybe')"
            :tile="buttonSelected('maybe')"
            class="mr-2"
            color="secondary"
            @click="rsvpClick({eventId: value.id, going: 'maybe'})"
          >
            Maybe
          </v-btn>

          <v-btn
            small
            :loading="loading"
            :outlined="!buttonSelected('no')"
            :tile="buttonSelected('no')"
            class="mr-2"
            color="accent"
            @click="rsvpClick({eventId: value.id, going: 'no'})"
          >
            Not Going
          </v-btn>
        </div>
      </div>
    </v-row>

    <v-img
      :src="value.image"
      :style="stackScreen ? '' : 'float: right'"
      :width="stackScreen ? '100%' : '33%'"
      :class="stackScreen ? 'mb-3' : ''"
      aspect-ratio=".8"
      :contain="stackScreen"
      max-height="calc(60vh - 70px)"
    >
    </v-img>

    <div :class="stackScreen ? '' : 'aspect-ratio-container'">
      <div
        :class="stackScreen ? '' : 'aspect-ratio-container-inside'"
      >
        <DisplayCard
          :class="stackScreen ? '' : 'third-height'"
          title="TIME"
          icon="mdi-clock-outline"
          :titleColor="titleColor"
          :iconColor="iconColor"
          noBottomBorder
        >
          <div class="d-flex align-content-start flex-wrap">
            <div class="d-block text-no-wrap">
              {{ formatDate(value.startDate) }}<span class="mx-2">-</span>
            </div>
            <div class="d-block text-no-wrap"> {{ formatDate(value.endDate) }}</div>
          </div>
        </DisplayCard>
        <DisplayCard
          :class="stackScreen ? '' : 'third-height'"
          title="DRESS CODE"
          icon="mdi-tshirt-crew"
          :titleColor="titleColor"
          :iconColor="iconColor"
          noBottomBorder
        >
          <div>
            <strong>{{ value.dressCode || "Every Day" }}</strong>
            {{ dressCodeText }}
          </div>
        </DisplayCard>
        <DisplayCard
          :class="stackScreen ? '' : 'third-height'"
          title="HOSTS AND CO-HOSTS"
          icon="mdi-account-multiple"
          :titleColor="titleColor"
          :iconColor="iconColor"
          noBottomBorder
        >
          <div>
            {{ hostsDescription }}
          </div>
        </DisplayCard>
      </div>
    </div>

    <DisplayCard
      title="LOCATION"
      icon="mdi-map-marker"
      :titleColor="titleColor"
      :iconColor="iconColor"
      noBottomBorder
    >
      <span v-html="locationDescription"></span>
    </DisplayCard>

    <DisplayCard
      title="DESCRIPTION"
      icon="mdi-text-subject"
      :titleColor="titleColor"
      :iconColor="iconColor"
      noBottomBorder
    >
      <span v-html="value.fullDescription"></span>
    </DisplayCard>
    <DisplayCard
      title="ATTENDANCE"
      icon="mdi-account-box-multiple-outline"
      :titleColor="titleColor"
      :iconColor="iconColor"
    >
      <template>
        <div v-if="isLoggedIn">
          <div v-if="rsvpInfo.yes.count > 0">
            <h5 class="font-weight-medium">Going:</h5>
            <div class="ml-8">
              <ListUsers :users="rsvpInfo.yes.users"/>
            </div>
          </div>
          <div v-else class="mb-2">
            <span class="font-weight-medium">Be the first to join!</span>
          </div>
          <div v-if="rsvpInfo.maybe.count > 0">
            <h6 class="font-weight-medium">Maybe:</h6>
            <div class="ml-8">
              <ListUsers :users="rsvpInfo.maybe.users"/>
            </div>
          </div>
          <div v-if="rsvpInfo.no.count > 0">
            <h6 class="font-weight-medium">Not Going:</h6>
            <div class="ml-8">
              <ListUsers :users="rsvpInfo.no.users"/>
            </div>
          </div>
        </div>
        <div v-else>
          <span>
            <span class="font-weight-medium">Going:</span>
            {{ rsvpInfo.yes.count }}
          </span>
          <span class="ml-2">
            <span class="font-weight-medium">Maybe:</span>
            {{ rsvpInfo.maybe.count }}
          </span>
          <span class="ml-2">
            <span class="font-weight-medium">Not Going:</span>
            {{ rsvpInfo.no.count }}
          </span>
        </div>
      </template>
    </DisplayCard>
    <LoginRequired ref="loginPrompt"/>
  </v-sheet>
</template>

<script>
const fb = require('@/core/config/firebase.js');
import {mapActions, mapGetters} from 'vuex';
import {format} from "date-fns";
import DisplayCard from './DisplayCard';
import LoginRequired from "@/core/components/core/LoginRequired";
import ListUsers from "./ListUsers";

export default {
  name: 'DisplayEventInfo',
  components: {
    DisplayCard,
    LoginRequired,
    ListUsers
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      titleColor: '#fa9d05',
      iconColor: '#b7b7b7',
      dressCodeDescription: {
        'Every Day': 'Appropriate casual clothing, no  ears, tails or other furry accessories',
        'Ears and Tails': 'Appropriate casual clothing with ears, tails or other furry accessories allowed',
        'Suit Ready': 'Appropriate fursuits are allowed, along with ears and tails or other furry accessories',
        'Formal': 'Clothing should be business casual or nicer'
      },
      stackScreen: false,
      loading: false,
      rsvpInfo: {
        yes: {
          count: 0,
          users: [],
          others: 0
        },
        no: {
          count: 0,
          users: [],
          others: 0
        },
        maybe: {
          count: 0,
          users: [],
          others: 0
        }
      },
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'getCurrentUser']),
    dressCodeText() {
      return this.dressCodeDescription[this.value.dressCode || "Every Day"]
    },
    selectedRSVP() {
      if (!this.value
        || !this.value.rsvp
        || !this.isLoggedIn
        || !this.value.rsvp[this.getCurrentUser.uid])
        return '';

      const rsvpInfo = this.value.rsvp[this.getCurrentUser.uid];
      return rsvpInfo.going + rsvpInfo.extra;
    },
    hostsDescription() {
      if (this.value.hosts && this.value.hosts.length > 0)
        return this.value.hosts;

      return 'Not specified'
    },
    locationDescription() {
      if (!this.value.location)
        return 'No location specified';

      let {name, street, city, state, zip} = this.value.location;

      if (name && name.length <= 0)
        name = undefined;

      if (street && street.length <= 0)
        street = undefined;

      if (city && city.length <= 0)
        city = undefined;

      if (state && state.length <= 0)
        state = undefined;

      if (zip && zip.length <= 0)
        zip = undefined;

      if (!city && !name && !street && !state && !street && !zip)
        return 'No location specified';

      let description = '';

      if (name)
        if (!city && !street && !state && !zip)
          return `<strong>${name}</strong>`;
        else
          description += `<strong>${name}:</strong> `;

      if (street)
        if (!city && !state && !zip)
          description += `${street}`;
        else
          description += `${street}, `;

      if (city)
        if (!state && !zip)
          description += `${city}`;
        else
          description += `${city}, `;

      if (state)
        description += `${state} `;

      if (zip)
        description += `${zip}`;

      return description;
    }
  },
  watch: {
    '$vuetify.breakpoint.smAndDown'(newValue) {
      this.stackScreen = newValue;
    },
    value: {
      deep: true,
      handler() {
        this.getRsvpInfo();
      }
    }
  },
  methods: {
    ...mapActions('events', ['pullEvent']),
    ...mapActions('user', ['getUser', 'pullUser']),
    formatDate(date) {
      if (!date)
        return '';

      return format(date, "EEE, MMM dd, yyyy hh:mm a")
    },
    async rsvpClick(rsvpInfo) {
      if (!this.isLoggedIn) {
        this.$refs.loginPrompt.showDialog('You need to login in order to RSVP for an event');
      }

      if (this.value
        && this.value.rsvp
        && this.value.rsvp[this.getCurrentUser.uid]
        && this.value.rsvp[this.getCurrentUser.uid].going === rsvpInfo.going
        && this.value.rsvp[this.getCurrentUser.uid].extra === rsvpInfo.extra)
        return;


      this.loading = true;
      try {
        await fb.rsvpEvent(rsvpInfo);
        await this.pullEvent(rsvpInfo.eventId);
      } catch (e) {
        console.error(e)

      }

      this.loading = false;
    },
    getExtraGuests(id) {
      if (!id
        || !this.value.rsvp[id]
        || !this.value.rsvp[id].extra
        || this.value.rsvp[id].extra <= 0) {
        return "";
      }

      return ` (+${this.value.rsvp[id].extra} friends)`
    },
    buttonSelected(going, extra) {
      if (!this.value
        || !this.value.rsvp
        || !this.getCurrentUser
        || this.getCurrentUser === 'verifying'
        || !this.value.rsvp[this.getCurrentUser.uid])
        return false;
      const rsvpInfo = this.value.rsvp[this.getCurrentUser.uid];

      if (!extra)
        return rsvpInfo.going === going;

      return rsvpInfo.going === going
        && rsvpInfo.extra === extra;
    },
    async getRsvpInfo() {
      const yes = {
        count: 0,
        users: [],
        others: 0
      };
      const no = {
        count: 0,
        users: [],
        others: 0
      };
      const maybe = {
        count: 0,
        users: [],
        others: 0
      };

      const loggedIn = this.isLoggedIn;

      const addUser = async (userId, userArray) => {
        let user = await this.getUser(userId);
        if (!user)
          user = await this.pullUser(userId);
        if (user)
          userArray.push(user)
      };

      if (this.value && this.value.rsvp) {
        const rsvps = Object.values(this.value.rsvp);
        for (let user of rsvps) {
          switch (user.going) {
            case 'yes':
              yes.count += 1;
              if (loggedIn)
                await addUser(user.user, yes.users);
              break;
            case 'maybe':
              maybe.count += 1;
              if (loggedIn)
                await addUser(user.user, maybe.users);
              break;
            case 'no':
              no.count += 1;
              if (loggedIn)
                await addUser(user.user, no.users);
              break;
          }
        }
      }

      this.rsvpInfo = {yes, maybe, no};
    },
  },
  async mounted() {
    this.stackScreen = this.$vuetify.breakpoint.smAndDown
    await this.getRsvpInfo();
  }
}
</script>
<style scoped>

.third-height {
  height: 33.4%
}

.aspect-ratio-container {
  position: relative;
  width: calc(67% - 6px);
  padding-top: calc(41.2% + 6px);
  overflow: hidden;
}

.aspect-ratio-container-inside {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
}

.selected-item {
  color: #fa9d05;
}
</style>
